import * as React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";

import * as styles from "./header.module.css";

const Header = ({ siteTitle, siteDescription, menuLinks }) => {
  // console.log(window.location.href);
  // console.log(window.location.href.includes("app-guide"));
  return (
    <header id="site-header" className={styles.masthead} role="banner">
      <noscript style={{ display: "none", visibility: "hidden" }}>
        <iframe
          title="google tag manager"
          src="https://www.googletagmanager.com/ns.html?id=GTM-PSC59SKH"
          height="0"
          width="0"
        ></iframe>
      </noscript>
      <div className={styles.header_container}>
        <div className={styles.masthead_info}>
          <Link to="/">
            <img
              src="/logo.svg"
              width="34"
              height="34"
              alt="d8ship logo"
              className={styles.site_logo}
            />
          </Link>
          {/* <div className={styles.site_title}>{siteTitle}</div> */}
          {/* <div>{siteDescription}</div> */}
        </div>
        <div className={styles.menu_container}>
          <ul className={styles.header_menu}>
            <li
              className={`${
                typeof window !== "undefined" &&
                window.location.href.includes("app-guide")
                  ? styles.active
                  : ""
              }`}
            >
              <Link to={"/app-guide"}>App Guide</Link>
            </li>
            <li
              className={`${
                typeof window !== "undefined" &&
                window.location.href.includes("contact-us")
                  ? styles.active
                  : ""
              }`}
            >
              <Link to={"/contact-us/"}>Contact</Link>
            </li>
          </ul>
          {/* <a href="/" className={styles.download_button}>
        <img src="/download_icon.svg" width="18" height="18" alt={siteTitle} />

        <p>Download</p>
      </a> */}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  siteDescription: PropTypes.string,
  menuLinks: PropTypes.array,
};

Header.defaultProps = {
  siteTitle: ``,
  siteDescription: ``,
  menuLinks: [],
};

export default Header;
